import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { childrenBusinessPageBreadcrumbs } from '@/pages/Business/config';
import { NavigateFunction } from 'react-router-dom';

export const childrenAuthorizationsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenBusinessPageBreadcrumbs(navigate),
  { label: 'Autorizaciones', onClick: () => navigate('/business/authorizations') },
];

export const childrenAuthorizationsDetailBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenAuthorizationsPageBreadcrumbs(navigate),
];
